import React, { ReactElement, useState, useEffect } from 'react'
import { SearchAccountsResponsePayload } from '@Types'
import AccountInfoBar from './AccountInfoBar'
import useGetMarginSummary from '../../api/useGetMarginSummary'
import { useGetAmountAvailable } from '../../api/useGetAmountAvailable'

export interface SummaryProps {
  accountData: SearchAccountsResponsePayload
  appTitle: string
  width?: string
}

function AccountSummaryHeader({ accountData, appTitle }: SummaryProps): ReactElement {
  const [isScrolling, setIsScrolling] = useState(false)
  useEffect(() => {
    window.addEventListener('scroll', () => {
      setIsScrolling(window.scrollY > 160)
    })
  }, [])

  const { data: marginData, status: marginStatus } = useGetMarginSummary(accountData.accountNumber)
  const { amountAvailable, isLoading: amountIsLoading } = useGetAmountAvailable(accountData.accountNumber)

  return (
    <AccountInfoBar
      appTitle={appTitle}
      accountTitle={accountData?.accountTitle}
      accountType={accountData?.accountType}
      accountNumber={accountData?.accountNumber}
      amountAvailable={amountAvailable}
      marginAmount={marginData?.liquidatingEquity}
      buyingPower={marginData?.overnightBuyingPower}
      metricWidth='18rem'
      totalWidth='100%'
      scroll={isScrolling}
      amountIsLoading={amountIsLoading}
      marginStatus={marginStatus}
    />
  )
}

export default AccountSummaryHeader
